import { NewBoxIcon } from './NewBoxIcon';

/**
 * author: Google
 * id 1ABEE375-A0DC-4262-9CCD-3B9C78B5FE7D
 * name new-box
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/new-box.svg
 * tags
 */
export const FiberNewIcon = NewBoxIcon;
export default FiberNewIcon